import { render, staticRenderFns } from "./FormCardProfileFornecedor.vue?vue&type=template&id=1cabaf1c"
import script from "./FormCardProfileFornecedor.vue?vue&type=script&lang=js"
export * from "./FormCardProfileFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports